import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import { Layout } from "../pages/landing/Layout";
import { Loader } from "../components/Loader";
import { PBox, PH1, PH2, PH4 } from "../theme/BaseTheme";
import { Input, Pagination } from "antd";
import ProductImageCard from "./ProductImageCard";
import { fetchUserProducts } from "../../actions/product";

class ProductImages extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            searchKey: "",
            page: parseInt(this.props.match.params.id),
            pageSize: 20,
            urlParams: new URLSearchParams(window.location.search),
            resultKey: "",
        };
    }
    async componentDidMount() {
        await this.props.fetchUserProducts(
            this.state.urlParams,
            (this.state.page - 1) * this.state.pageSize,
            this.state.pageSize
        );
        await this.setState({
            searchKey: this.state.urlParams.get("key"),
            resultKey: "user_products" + "_" + this.state.urlParams.toString(),
        });
        await this.setState({ isLoading: false });
    }

    render() {
        if (this.state.isLoading) {
            return <Loader />;
        }
        return (
            <Layout>
                <Helmet>
                    <title>User Product Images</title>
                    <meta
                        name="description"
                        content="Creating beautiful product images is now easy and quick. Patternful.ai's AI-powered product image generator make it easy for you to produce distinctive, attractive, and ready-to-use product images."
                    />
                    <meta
                        name="keywords"
                        content="Product Image Generator, Product Image AI, Product Image Maker, Product Image APP, Product Image Online Generator, Print On Demand, Product Design, Patternful, Patternful AI"
                    />
                </Helmet>
                <PBox css={styles}>
                    <PH2>My Product Images</PH2>
                    {/*<PBox className="patterns-search">
                        <Input.Search
                            placeholder="Search for product images"
                            onSearch={(value) => {
                                window.location.href = `/product-images/1?key=${value}`;
                            }}
                        />
                    </PBox>                        

                    {this.props.searchResults[this.state.resultKey]
                        ?.totalSearchProducts !== 0 && (
                        <PH4>Search results for {this.state.searchKey}</PH4>
                    )}
                    {this.props.searchResults[this.state.resultKey]
                        ?.totalSearchProducts === 0 && (
                        <PH4>No Results Found.</PH4>
                    )}*/}
                    {this.props.searchResults[this.state.resultKey]
                        ?.totalSearchProducts !== 0 && (
                        <PBox className="patterns-container">
                            {this.props.searchResults[
                                this.state.resultKey
                            ]?.searchProducts?.map((product, idx) => {
                                return (
                                    <ProductImageCard
                                        product_uuid={product.product_uuid}
                                        image_url={product.src}
                                        prompt={product.prompt}
                                    />
                                );
                            })}
                        </PBox>
                    )}
                    {this.props.searchResults[this.state.resultKey]
                        ?.totalSearchProducts !== 0 && (
                        <PBox className="pattern-gallery-pagination">
                            <Pagination
                                defaultCurrent={this.state.page}
                                total={parseInt(
                                    this.props.searchResults[
                                        this.state.resultKey
                                    ]?.totalSearchProducts
                                )}
                                pageSize={this.state.pageSize}
                                showSizeChanger={false}
                                showQuickJumper={true}
                                onChange={async (page) => {
                                    window.location.href = `/product-images/${page}?${this.state.urlParams.toString()}`;
                                }}
                            />
                        </PBox>
                    )}
                </PBox>
            </Layout>
        );
    }
}

const styles = {
    padding: "0 1.5rem",
    maxWidth: "80rem",
    margin: "2rem auto",
    "@bp2": { marginTop: "4rem" },
    "@bp4": { paddingLeft: "2rem", paddingRight: "2rem" },
    "& h2": { marginBottom: "3rem" },
    "& .patterns-search": {
        marginBottom: "3rem",
    },
    "& .patterns-container": {
        margin: "0 auto 6rem auto",
        display: "grid",
        gap: "1rem",
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        "@bp2": { gridTemplateColumns: "repeat(3, minmax(0, 1fr))" },
        "@bp4": { gridTemplateColumns: "repeat(4, minmax(0, 1fr))" },
    },
    "& .ant-card-meta-description": { color: "#1b1b1b" },
    "& .pattern-gallery-pagination": {
        display: "flex",
        justifyContent: "center",
        marginBottom: "6rem",
    },
};

function mapStateToProps(state) {
    return {
        userAccount: state.authReducer?.userAuth.userAccount,
        searchResults: state.productReducer?.fetchUserProducts,
    };
}

export default connect(mapStateToProps, { fetchUserProducts })(
    withRouter(ProductImages)
);
